import { debounce } from '../utils';

jQuery(document).ready(() => {
  /**
   *
   * Menu Burger Click
   *
   */

  const burger = $('.navbar-burger');

  burger.on('click', (event, element) => {
    let menuId = burger.data('target');
    burger.toggleClass('is-active');
    $('#' + menuId).toggleClass('is-active');
    $('html').toggleClass('is-clipped');
  });

  /**
   *
   * Fixed top but with topbar margin when top
   *
   */

  const temoin = document.querySelector('.topbar');

  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        $('.banner .navbar.is-fixed-top').addClass('is-top');
        $('.banner .navbar.is-fixed-top').removeClass('is-scrolled');
      } else {
        $('.banner .navbar.is-fixed-top').addClass('is-scrolled');
        $('.banner .navbar.is-fixed-top').removeClass('is-top');
      }
    });
  };

  const menuTrigger = new IntersectionObserver(callback, {
    rootMargin: '16px',
  });

  if (temoin) {
    menuTrigger.observe(temoin);
  }

  /**
   *
   * AlignFull JS solution
   *
   */
  const blockWorkFull = () => {
    let bodyWidth = $('body').width();
    $('.wp-block-wrap').each((index, el) => {
      $(el).css({
        paddingLeft: 0, // Reset fix padding
        paddingRight: 0, // Reset fix padding
        marginLeft: 'calc( -' + bodyWidth + 'px / 2 + 100% / 2 )',
        marginRight: 'calc( -' + bodyWidth + 'px / 2 + 100% / 2 )',
        maxWidth: bodyWidth,
      });
    });
  };

  blockWorkFull();
  $(window).on('resize', debounce(blockWorkFull, 50));

  /**
   *
   * Scroll TOP
   *
   */
  $('.go-up').on('click', () => {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });
});
